<script>

</script>

<div class="col mb-4">
    <div class="alert alert-info m-0 d-flex justify-content-between">

        <div id="isLoading" class="mr-4"></div>

        <h5 id="search-summary"
            class="no-margin p-0 m-0 w-100"
            aria-live="polite"
            aria-atomic="true"
            style="display: flex;"
        >Loading...</h5>

    </div>

</div>

<style>

    #isLoading {
        display: inline-flex;
        width: 1.4em;
        height: 1.4em;
        border: 5px solid #fcde8a;
        border-radius: 50%;
        border-top-color: #fff;
        animation: spin 1s ease-in-out infinite;
        -webkit-animation: spin 1s ease-in-out infinite;
    }

    @keyframes spin {
        to { -webkit-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        to { -webkit-transform: rotate(360deg); }
    }
</style>